<script>
    import BaseAnimation from '../BaseAnimation';

    export default {
        name: 'fade-left-animation',

        mixins: [BaseAnimation],

        props: {
            element: {
                type: Function,
                required: true,
            },
        },

        beforeDestroy() {
            if (this.motionAccepted) {
                this.scrollTrigger.getById(this.uid).kill();
            }
        },

        methods: {
            /**
             * Set the initial state of the animated element.
             */
            setInitialStates() {
                let el = this.element();

                if (el._isVue) {
                    el = el.$el;
                }

                el.style.opacity = 0;
            },

            /**
             * Reveal animation.
             */
            reveal() {
                let el = this.element();

                if (el._isVue) {
                    el = el.$el;
                }

                this.gsap.set(el, {
                    opacity: 0,
                    x: 100,
                });

                this.gsap.fromTo(
                    el,
                    {
                        opacity: 0,
                        x: 100,
                    },
                    {
                        opacity: 1,
                        x: 0,
                        scrollTrigger: {
                            trigger: el,
                            id: this.uid,
                            start: 'top 90%',
                        },
                    },
                );
            },
        },
    };
</script>
